// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"6f98ab88","275":"b1281ac4","347":"87598209","394":"292b10c9","524":"f86f0f88","656":"6f85de57","753":"1ab9ba0e","754":"e4cee42f"}[chunkId] + ".chunk.js";
};